import Vue from 'vue';
import Router from 'vue-router';
import routes from './config/routes';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
});

// Hooks
// @see https://router.vuejs.org/guide/advanced/meta.html
router.beforeEach((to, from, next) => {
  const publicAccess = [
    'login',
    'register',
    'forgotPassword',
  ];
  // Check login
  const token = sessionStorage.getItem('token');
  const storeToken = store.state.administrator.token;

  if (!storeToken && token) {
    store.commit('administrator/me/setToken', token);
  }

  if (publicAccess.includes(to.name)) {
    return next();
  }

  if (!token) {
    return next({ name: 'login' });
  }

  // Check if user has access to backend
  store.dispatch('administrator/me/fetch');
  return next();
});

export default router;
